import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 4a4 4 0 1 1 0 8a4 4 0 0 1 0 -8","key":"svg-0"}],["path",{"d":"M12 12v8","key":"svg-1"}],["path",{"d":"M9 17l3 3l3 -3","key":"svg-2"}]]

/**
 * IconSwipeDown
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc3dpcGUtZG93biIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTIgNGE0IDQgMCAxIDEgMCA4YTQgNCAwIDAgMSAwIC04IiAvPgogIDxwYXRoIGQ9Ik0xMiAxMnY4IiAvPgogIDxwYXRoIGQ9Ik05IDE3bDMgM2wzIC0zIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/swipe-down
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconSwipeDown = createReactComponent('outline', 'swipe-down', 'SwipeDown', __iconNode);

export default IconSwipeDown;